import { AlertCircle, AlertTriangle } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { SubmissionWarning } from '@/lib/submissionWarnings';

interface PreviewRowProps {
  label: string;
  value: string | number | null | undefined;
  warning?: SubmissionWarning;
}

export function PreviewRow({ label, value, warning }: PreviewRowProps) {
  if (value === null || value === undefined || value === '') return null;

  return (
    <div className={cn('grid grid-cols-3 gap-2', warning && 'bg-amber-50/50 -mx-2 px-2 py-1 rounded')}>
      <span className='font-medium text-gray-500 col-span-1 flex items-center gap-1'>
        {label}
        {warning ? (
          <span title={warning.message}>
            {warning.severity === 'error' ? (
              <AlertCircle className='h-3.5 w-3.5 text-red-500' />
            ) : (
              <AlertTriangle className='h-3.5 w-3.5 text-amber-500' />
            )}
          </span>
        ) : null}
      </span>
      <span className={cn('col-span-2', warning?.severity === 'error' ? 'text-red-700' : 'text-gray-900')}>
        {value}
      </span>
    </div>
  );
}
